import { v4 } from 'uuid';

export const randomId = (prefix: string = ''): string => {
  return prefix + v4().replace(/-/g, '');
};
